<template>
  <div class="dayplan-table-outer-container bg-white p-4">

    <el-radio-group v-model="view_mode">
      <el-radio-button label="actual">Actual</el-radio-button>
      <el-radio-button label="target">Target</el-radio-button>
    </el-radio-group>

    <div class="month-table mb-4 unselectable">
      <div class="month-table-heading">
        <div class="month-table-row">
          <div class="month-table-head">
            TSC
          </div>
          <div class="month-table-head">
            Commitment
          </div>
          <div
            v-for="day in viewDateRangeMonth"
            :key="day.$key"
            @click="onGoToDay(day)"
            :class="{
              'month-table-head clickable': true,
              'month-table-head--is-today': day.is_today,
              'month-table-head--is-weekend': day.is_weekend,
            }">
            <span class="month-table-day">{{day.view_date|dayFromDate}}</span>
            {{day.view_date|dayOfMonthFromDate}}
          </div>
          <div class="month-table-head">
            &Sigma;
          </div>
          <div class="month-table-head">
            <!-- Target -->
            <font-awesome-icon icon="bullseye" />
          </div>
        </div>
      </div>

      <div class="month-table-body">
        <template v-for="tsc in timeslotCollections">
          <!--
          <suggestion-category-header
            :key="tsc.$id"
            style="margin-top: 1em;"
            :name="tsc.name"
            :magic-timeslots="[]"
            :tscId="tsc.$id"
            :icon="tsc.icon"
          />
          -->

          <div
            class="month-table-row"
            v-for="(commitment, idx) in tsc.commitments"
            :key="commitment.$key">

            <!-- row-count: 3; -->
            <div :style="{ backgroundColor: tsc.icon.bgColor }" class="month-table-tsc-cell">
              <span v-if="idx === 0">{{tsc.name}}</span>
            </div>

            <div class="month-table-row-head">
              <router-link :to="'/goal/'+commitment.goalId+'/dashboard#'+commitment.commitmentId">
                {{commitment.meta.name}}
              </router-link>
              <!-- <pre class="mini-pre">{{commitment}}</pre> -->
            </div>

            <div
              v-for="day in viewDateRangeMonth"
              :key="day.$key"
              :class="{
                'month-table-cell': true,
                'month-table-cell--is-today': day.is_today,
                'month-table-cell--is-weekend': day.is_weekend,
                'month-table-cell--is-selected': dragCellActive( day.$key, commitment.commitmentId ),
              }"
              @mousedown="onCellMouseDown( day.$key, commitment.commitmentId )"
              @mousemove="onCellMouseMove( day.$key, commitment.commitmentId )"
              @mouseup="onCellMouseUp( day.$key, commitment.commitmentId )">

              <!-- {{dragCellActive( day.$key, commitment.commitmentId )}} -->

              <template v-if="view_mode === 'target'">
                <template v-if="commitmentTimeByCommitmentAndDay[ commitment.commitmentId ][ day.$key ]">
                  <strong>{{commitmentTimeByCommitmentAndDay[ commitment.commitmentId ][ day.$key ]|hours}}</strong>
                </template>
                <template v-else-if="false">
                  <span class="text-gray">{{commitment.committedTimePerDay|hours}}</span>
                </template>
              </template>
              <template v-if="view_mode === 'actual'">
                <em>{{( dayplanner_planned_daily_time_by_commitment[ day.$key ] ? dayplanner_planned_daily_time_by_commitment[ day.$key ][ commitment.commitmentId ] : null) | hours}}</em>
              </template>

              <!-- TODO: Slow... -->
              {{commitment.startDate.format('YYMMDD') === day.$key.slice(4) ? '🎉' : ''}}
              {{commitment.endDate.format('YYMMDD') === day.$key.slice(4) ? '🏁' : ''}}

              <!-- {{commitmentTimeByCommitmentAndDay[ commitment.commitmentId ][ day.$key ] || commitment.committedTimePerDay}} -->
              <!-- <el-input v-model="matrix" /> -->

            </div>
            <div class="month-table-cell month-table-cell--is-sum">
              <template v-if="view_mode === 'target'">
                {{sumsByCommitment[ commitment.commitmentId ]|hours}}
              </template>
              <template v-if="view_mode === 'actual'">
                <!-- TODO: This is NOT per month, but all loaded sessions! -->
                <em>{{dayplanner_planned_time_overall_by_commitment[ commitment.commitmentId ]|hours}}</em>
              </template>
            </div>
            <div class="month-table-cell month-table-cell--is-sum">
              {{commitment.committedTime|hours}}
            </div>
          </div>

          <!-- Sum by TSC and day -->
          <!--
          <div class="month-table-row">
            <div class="month-table-cell"></div>
            <div class="month-table-cell">{{tsc.name}}</div>
            <div
              v-for="day in viewDateRangeMonth"
              :key="day.$key"
              class="month-table-cell"
              :style="{
                backgroundColor: hoursToColor( sumsByDay[ day.$key ] / 3600, tsc_per_day... )
              }">
              {{sumsByDayAndTSC[ day.$key ][ tsc.$id ]|hours}}
            </div>
            <div class="month-table-cell"></div>
            <div class="month-table-cell"></div>
          </div>
          -->
        </template>

        <div class="month-table-row" v-if="view_mode === 'target'">
          <div class="month-table-cell"></div>
          <div class="month-table-cell month-table-column-head">&Sigma;</div>
          <div
            v-for="day in viewDateRangeMonth"
            :key="day.$key"
            class="month-table-cell"
            :style="{
              backgroundColor: hoursToColor( sumsByDay[ day.$key ] / 3600, maxHoursPerDay )
            }">
            {{sumsByDay[ day.$key ]|hours}}
          </div>
          <div class="month-table-cell">
            <em>{{Object.keys(sumsByDay).reduce((acc,val) => acc + sumsByDay[val], 0)|hours}}</em>
          </div>
          <div class="month-table-cell">
            &nbsp;
          </div>
        </div>
      </div>

    </div>

    <router-link to="/commitments">Go to Commitment settings</router-link>

<pre class="mini-pre mt-2 float-right" style="width: 150px">
🎉 = start date
🏁 = finish date
</pre>

    <!--
    <pre class="mini-pre">timeslotCollections:{{timeslotCollections}}</pre>
    <pre class="mini-pre">dayplanner_planned_time_overall_by_commitment:{{dayplanner_planned_time_overall_by_commitment}}</pre>
    <pre class="mini-pre">dayplanner_planned_daily_time_by_commitment:{{dayplanner_planned_daily_time_by_commitment}}</pre>
    <pre class="mini-pre">view_mode:{{view_mode}}</pre>
    <pre class="mini-pre">viewDateRangeMonth[0]:{{viewDateRangeMonth[0]}}</pre>
    <pre class="mini-pre">viewDateRange:{{viewDateRange}}</pre>
    <pre class="mini-pre">dragStartDateKey:{{dragStartDateKey}} | dragStartCommitmentId:{{dragStartCommitmentId}}</pre>
    <pre class="mini-pre">dragEndDateKey:{{dragEndDateKey}} | dragEndCommitmentId:{{dragEndCommitmentId}}</pre>
    <pre class="mini-pre">dragDirection:{{dragDirection}}</pre>
    <pre class="mini-pre">commitmentTimeByCommitmentAndDay:{{commitmentTimeByCommitmentAndDay}}</pre>
    <pre class="mini-pre">activeGoalIds:{{activeGoalIds}}</pre>
    <pre class="mini-pre">activeCommitmentIds:{{activeCommitmentIds}}</pre>
    <pre class="mini-pre">sumsByCommitment:{{sumsByCommitment}}</pre>
    <pre class="mini-pre">sumsByDay:{{sumsByDay}}</pre>

    <div
      v-for="n in 11"
      :key="n"
      :style="{ backgroundColor: hoursToColor(n-2.1,8) }"
      class="debug-box">
      {{n-2}}
    </div>
    -->

  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import Vue from 'vue'
import moment from "@/moment-gp"
import util from '@/util'
import Color from 'color'
import { mapReady } from '@/api/misc'

// xTODO: Bei wechsel in table auf ganze Woche monat zeigen
// xTODO: Allow to select cells like excel
// xTODO: show sum per commitment
// xTODO: show sup per tsc / column
// xTODO: Commitments verlinken
// xTODO: Tage verlinken
// xTODO: Bereits geplante Zeiten anzeigen
// xTODO: Drag and drop support für commitments
// xTODO: Start und End Datum anzeigen ( + Legende ? )
// xTODO: Sort by sortidx -> prioidx

// TODO: Praktisch wäre in dem popover eine Option von Enddatum auf für immer oder bis x Stunden erledigt sind über dropdown oder Radio auswählen zu könne

// TODO: Active/Inactive = Automatische plannung übernehmen und einbauen

const day2num = (day) => parseInt(day.slice(4));

export default {
  props: {
    viewDateRange: {
      // INFO: only month is used
      required: true
    },
    color1: {
      default: ( new Color('green').desaturate(0.6).lighten(2.5).hex() ),
    },
    color2: {
      default: ( new Color('red').desaturate(0.4).lighten(0.5).hex() ),
    }
  },
  data() {
    return {
      view_mode: 'target',
      maxHoursPerDay: 8, // HACK
      dragStartDateKey: null,
      dragStartCommitmentId: null,
      dragEndDateKey: null,
      dragEndCommitmentId: null,
      dragDirection: null,
      viewDateRangeMonth: [],
      commitmentTimeByCommitmentAndDay: {},
    }
  },
  watch: {
    viewDateRange(v) {
      this.generateDataTable();
    }
  },
  created() {
    this.generateDataTable();
  },
  computed: {
    ...mapReady("goals", "commitments", "optimizer_input"),
    ...mapGetters("dayplanner", [
      "dayplanner_planned_time_overall_by_commitment",
      "dayplanner_planned_daily_time_by_commitment",
    ]),

    commitmentListAll() {
      return this.$models.commitment.getters.commitment_list_all
    },

    timeslotCollectionList() {
      return this.$models.timeslotCollection.subscribeList().itemsSorted;
    },

    timeslotCollections() {
      return this.timeslotCollectionList.map( tsc => {
        let commitmentsFound = this.commitmentListAll.filter(
          commitment => commitment.user.timeslotCollectionId === tsc.$id
        ).sort(util.sorter.by_user_prioidx);

        return Object.assign(tsc, {
          icon: {
            symbol: "filter",
            bgColor: tsc.$state.color,
            fgColor: "#ffffff"
          },
          commitments: commitmentsFound
        });
      });
    },

    activeCommitmentIds() {
      return this.commitmentListAll.map(commitment => commitment.commitmentId)
    },

    activeGoalIds() {
      let goalIds = this.commitmentListAll.map(commitment => commitment.goalId);
      return [...new Set(goalIds)]; // return unique values
    },

    sumsByCommitment() {
      let result = {};
      const commitetTimeArray = this.commitmentTimeByCommitmentAndDay
      Object.keys(commitetTimeArray).forEach(commitmentId => {
        result[ commitmentId ] = Object.keys(commitetTimeArray[ commitmentId ])
        .reduce( (acc, dateKey) => {
          return acc + commitetTimeArray[ commitmentId ][ dateKey ];
        }, 0)
      })
      return result;
    },

    sumsByDay() {
      // TODO: Should take default values into account (committedTimePerDay)
      let result = {};
      const commitetTimeArray = this.commitmentTimeByCommitmentAndDay
      this.viewDateRangeMonth.forEach(date => {
        result[ date.$key ] = Object.keys(commitetTimeArray)
        .reduce( (acc, commitmentId) => {
          return acc + ( commitetTimeArray[ commitmentId ][ date.$key ] || 0);
        }, 0);
      })
      return result;
    },

    sumsByDayAndTSC() {
      return null
    },
  },
  methods: {

    generateDataTable() {

      // Generate view date range
      let from = this.viewDateRange[0].view_date.clone().startOf('month');
      let to   = this.viewDateRange[0].view_date.clone().endOf('month');
      let cur  = from.clone();
      let days = [];

      console.log("generateDataTable", from.format('ll'), "-", to.format('ll'))

      do {
        days.push({
          $key:       'day-' + cur.format('YYMMDD'),
          view_date:  cur.clone(),
          is_today:   cur.isSame(moment(), 'day'), // or selected ?
          is_weekend: (cur.day() === 0) || (cur.day() === 6),
        });
      } while ( cur.add(1, 'days').diff( to ) <= 0 )

      this.viewDateRangeMonth = days;

      // Load daily commitment settings
      // TODO: Requires everything to be ready
      // console.log("activeGoalIds", this.activeGoalIds)

      this.commitmentSettingsGenericListByGoal = [];

      this.activeCommitmentIds.forEach(commitmentId => {
        Vue.set(this.commitmentTimeByCommitmentAndDay, commitmentId, {});
      })

      this.activeGoalIds.forEach(goalId => {
        let commitmentSettings = this.$models.commitmentDailySettings
          .with({ goalId })
          .fetchQuery({ // HACK: You're trying to sync a path that has already been synced by a query. This is not supported.
            startAt: from.format("YYMMDD"),
            endAt:   to.format("YYMMDD"),
          });

        commitmentSettings.$promise.then(x => {

          commitmentSettings.itemsAsArray().forEach(setting => {
            let dateKey = 'day-' + setting.$id;
            Object.keys(setting.$state).forEach(commitmentId => {

              let committedTimeDaily = setting.$state[ commitmentId ].committedTimeDaily;
              Vue.set(this.commitmentTimeByCommitmentAndDay[commitmentId], dateKey, committedTimeDaily );
            })
          })
        })

        this.commitmentSettingsGenericListByGoal[ goalId ] = commitmentSettings;
      })
    },

    dragCellActive( dateKey, commitmentId ) {

      // TODO: Return css class instead
      // TODO: return class with "border-radius: 100% 0 0 100%;" for first element

      if ( this.dragDirection === 'commitment' ) {

        let cell  = day2num( dateKey );
        let start = day2num( this.dragStartDateKey );
        let end   = day2num( this.dragEndDateKey );
        if ( start > end ) {
          [start, end] = [ end, start ]
        }

        return commitmentId === this.dragStartCommitmentId
               && cell >= start && cell <= end;
      }

      return false;
    },

    hoursToColor( value, max ) {
      let r = (value || 0) / max;
      return new Color(this.color1).mix(new Color(this.color2), r);
    },

    onCellMouseDown( dateKey, commitmentId ) {
      // console.log("onCellMouseDown", dateKey, commitmentId );

      this.dragEndDateKey = this.dragStartDateKey = dateKey;
      this.dragEndCommitmentId = this.dragStartCommitmentId = commitmentId;
      this.dragDirection = 'commitment';
    },

    onCellMouseMove( dateKey, commitmentId ) {

      if ( !this.dragStartDateKey ) {
        this.dragEndDateKey = null;
        this.dragEndCommitmentId = null;
        this.dragDirection = null;
        return;
      }

      this.dragEndDateKey = dateKey;
      this.dragEndCommitmentId = commitmentId;

      if ( this.dragStartCommitmentId === this.dragEndCommitmentId ) {
        this.dragDirection = 'commitment';
      }

      // Not supported!
      /* if ( this.dragStartDateKey === this.dragEndDateKey ) {
        this.dragDirection = 'day';
      } */
    },

    onCellMouseUp( dateKey, commitmentId ) {

      let from = day2num(this.dragStartDateKey);
      let to   = day2num(this.dragEndDateKey);

      const onReset = () => {
        this.dragEndDateKey = this.dragStartDateKey = null;
        this.dragEndCommitmentId = this.dragStartCommitmentId = null;
        this.dragDirection = null;
      }

      if ( from > to ) {
        [ from, to ] = [ to, from ];
      }

      let currentValue = this.commitmentTimeByCommitmentAndDay[ this.dragStartCommitmentId ][ this.dragStartDateKey ] || null;

      this.showBatchUpdatePrompt(this.dragStartCommitmentId, from, to, currentValue).then(() => {
        onReset();
      }).catch(onReset);
    },

    showBatchUpdatePrompt( commitmentId, from, to, currentValue ) {

      return this.$prompt(
        'Please enter the amount of hours',
        'Update daily commitment', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          inputValue: currentValue / 3600,
          closeOnClickModal: false,
      }).then(({ value }) => {

        // TODO: https://github.com/globalizejs/globalize -> Globalize.numberParse
        value = parseFloat(value.replace(',', '.'));
        if ( util.isNumeric(value) && value >= 0 ) {

          this.batchUpdate( commitmentId, from, to, value ).then(() => {
            this.$notify({
              type: 'success',
              message: "Successfully updated"
            });
          });
        } else {
          this.$notify({ type: 'error', message: "Invalid input" });
        }
      })
    },

    batchUpdate( commitmentId, from, to, value ) {

      let goalId = this.commitmentListAll
        .find(commitment => commitment.commitmentId === commitmentId)
        .goalId

      let n_update = to - from + 1;
      if ( !( n_update >= 1 && n_update <= 31 ) ) {
        throw new Error('invalid-input')
      }

      let committedTimeDaily = value === 0 ? null : value * 3600;
      // console.log("value", committedTimeDaily, commitmentId, goalId, from, to, n_update);

      let current = from;
      let promiseList = [];
      do {
        // TODO: This needs optimization (batch update!)
        // TODO: Use moment objects instead! This only within a month!
        // INFO: (function(foo) {})(current); --> kills loop!?

        ((dateKey) => { // Closure required to capture value of 'current'

          // let promise = Promise.resolve();
          let promise = this.$models.commitmentDailySettingsItem
            .with({
              goalId: goalId,
              dateString: current.toString(),
            })
            .update(commitmentId, {
              committedTimeDaily: committedTimeDaily
            })
          promise.then(() => {
            // Update local data
            Vue.set(this.commitmentTimeByCommitmentAndDay[commitmentId], dateKey, committedTimeDaily );
          });
          promiseList.push(promise);

        })('day-' + current)

        current += 1;

      } while ( current - to <= 0 )

      return Promise.all(promiseList);
    },

    ...mapMutations('dayplanner', [
      'SET_VIEW_RANGE',
      'SELECT_DATE',
    ]),
    onGoToDay( day ) {

      this.SET_VIEW_RANGE({
        from: day.view_date.toStore(),
        to:   null,
      });

      this.SELECT_DATE( day.view_date.toStore() );

      this.$router.push('/dayplanner')
    },
  },
  filters: {
    dayFromDate(date) {
      return moment(date).format('dd');
    },
    dayOfMonthFromDate(date) {
      return moment(date).format('D');
    },
    hours(sec) {
      if ( sec === undefined || sec === null ) {
        return ''
      }
      return ( Math.round( sec / 3600 * 10) / 10 ) + 'h';
    }
  },
  components: {
  }
};
</script>

<style lang="scss">
$border-color: #bbb;
$text-color: black;
$bg-color: #eee;

.month-table-row { display: table-row; }
.month-table-tsc-cell,
 .month-table-row-head,
 .month-table-cell,
 .month-table-head { display: table-cell; }
.month-table-heading { display: table-header-group; }
.month-table-body { display: table-row-group; }

.month-table {
  display: table;
  border: 1px solid $border-color;
  width: 100%;
  border-collapse: collapse;
}
.month-table .month-table-row-head,
.month-table .month-table-cell,
.month-table .month-table-head {
  padding: 2px 6px;
}
.month-table .month-table-body .month-table-cell {
  border: 1px solid $border-color;
  font-size: 13px;
  text-align: center;
  vertical-align: middle;
  max-width: 40px;
}
.month-table .month-table-cell:nth-child(even) {
  /*background: #FFFFFFB0;*/
}
.month-table .month-table-cell:nth-child(odd) {
  /*background: #AAAAAAB0;*/
}
.month-table .month-table-tsc-cell {
  border-left: 1px solid darken($bg-color, 25%);
  text-align: center;
  color: white;
}
.month-table .month-table-row-head {
  background: $bg-color;
  border: 1px solid darken($bg-color, 25%);
  text-align: left;
  vertical-align: middle;
  font-weight: bold;
}
.month-table .month-table-column-head {
  background: $bg-color;
  text-align: center;
  vertical-align: middle;
}
.month-table .month-table-heading {
  border-bottom: 2px solid $border-color;
}
.month-table .month-table-heading .month-table-head {
  font-size: 15px;
  font-weight: bold;
  color: $text-color;
  text-align: center;
  border-left: 1px solid $border-color;
  /*min-width: 250px;*/
}
.month-table .month-table-heading .month-table-head:first-child {
  border-left: none;
}
.month-table .month-table-head--is-weekend {
  color: var(--green) !important;
}
.month-table .month-table-head--is-today {
  color: var(--red) !important;
}
.month-table .month-table-cell--is-today {
  background-color: lighten($bg-color, 4%);
}
.month-table .month-table-head:hover,
.month-table .month-table-body .month-table-cell:hover {
  background-color: $bg-color;
}
.month-table .month-table-cell--is-selected {
  background-color: #45aaf266 !important;
  border: 1px solid #45aaf266 !important;
}
// TODO: move to globals
.unselectable {
  -moz-user-select: -moz-none;
  -khtml-user-select: none;
  -webkit-user-select: none;

  /*
  Introduced in IE 10.
  See http://ie.microsoft.com/testdrive/HTML5/msUserSelect/
  */
  -ms-user-select: none;
  user-select: none;
}
.debug-box {
  width: 2em;
  height: 2em;
  float: left;
}
</style>
